import React, { useState, useEffect, useRef } from "react";
import { LabelWithControl } from "components/common/LabelControl";
import {
  Button,
  Box,
  Grid,
  Typography,
  FormControl,
  Select,
  LinearProgress,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
  InputLabel,
} from "@mui/material";
import AutoComplete from "components/common/AutoComplete";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  downloadType,
} from "data/data";
import { useDispatch, useSelector } from "react-redux";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions"
import { All_LOCATION, DEPOT, STORE, EMERGENCYORDER_DOWNLOAD_REPORT_TYPE, PAGE, SUPPLYCHAIN } from "components/common/CONSTANTS";
import { postFileAccess, showErrorMessageByCode } from "services/commonServices";
import { EMERGENCY_ORDER_DOWNLOAD_SUCCESS, SOMS_API_KEY, CORRECT_VALUE_SELECTION_EMERGENCYORDER } from "services/CONSTANTS";
import { generateDownloadReport } from "services/downloadCustomerDemandsService";
import { encryptString } from "components/common/EncryptDecrypt";


export const DownloadEmergencyOrderReport = () => {
  const userType = useSelector((state) => {
    return state.user
  }
  );
  const { accessiblePages } = userType.userType;
  const loginResponse = userType.loginResponse;
  const { locationResponse } = useSelector((state) => state.locations);
  const [showDownloadUrl, setShowDownloadUrl] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [downloadFileTime, setDownloadFileTime] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [showFileDownloadPopup, setShowFileDownloadPopup] = useState(false);
  const [type, setType] = useState("all");
  const [depotId, setDepotId] = useState(All_LOCATION.locationId);
  const [storeId, setStoreId] = useState(All_LOCATION.locationId);
  const [orderDate, setOrderDate] = useState(dayjs());
  const [errors, setErrors] = useState(null);
  const [depoError, setDepoError] = useState(null);
  const [storeError, setStoreError] = useState(null);
  const [storeIdInputValue, setStoreIdInputValue] = React.useState("");
  const [storeIdOptions, setStoreIdOptions] = React.useState([All_LOCATION]);
  const [depotIdInputValue, setDepotIdInputValue] = React.useState("");
  const [depotIdOptions, setDepotIdOptions] = React.useState([All_LOCATION]);
  const dispatch = useDispatch();
  const toShowCustListRef = useRef([]);
  const [channelList, setChannelList] = useState([]);
  const [storeObjects, setStoreObjects] = useState([])
  const [depotObjects, setDepotObjects] = useState([])

  useEffect(() => {
    if (accessiblePages) {
      const channels = accessiblePages[PAGE.DOWNLOAD_EMERGENCY_ORDERS.key];
      setChannelList(channels);
      const toShowCustList = [];
      const stores = []
      const depots = []
      locationResponse.forEach(location => {
        if (channels.includes(location.channel.toLowerCase())) {
          toShowCustList.push(location);
        }
        if (location.locationType === STORE) {
          stores.push(location);
        }
        if (location.locationType === DEPOT) {
          depots.push(location);
        }
      })
      setStoreObjects(stores);
      setDepotObjects(depots);
      toShowCustListRef.current = toShowCustList;
      let customerListFinal = [{ CustomerId: "all", CustomerName: "All", CustomerType: "wholesale" }];
      toShowCustList.forEach(v => {
        if (v.channel === 'Wholesale' && v?.customerType !== '' && v.channel !== '') {
          customerListFinal.push({ CustomerId: "wholesale", CustomerName: "Wholesale", CustomerType: v.channel.toLowerCase() })
        } else if (v?.customerType !== '' && v.channel !== '') {
          customerListFinal.push({ CustomerId: v?.customerType, CustomerName: v?.customerType, CustomerType: v.channel.toLowerCase() })
        }
      });

      function uniqueList(data, key) {
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      }

      let finalListOfCustomerArray = uniqueList(customerListFinal, it => it.CustomerId)

      let indexRetailStore = finalListOfCustomerArray?.findIndex(customer => customer?.CustomerName === 'Retail Store');

      // Check if 'Retail Store' is not already at the 1st index and swap accordingly
      if (indexRetailStore !== 1) {
        let temp = finalListOfCustomerArray[1];
        finalListOfCustomerArray[1] = finalListOfCustomerArray[indexRetailStore];
        finalListOfCustomerArray[indexRetailStore] = temp;
      }

      setCustomerList(finalListOfCustomerArray.filter(x => {
        return channels.includes(x?.CustomerType)
      }))
    }
  }, [accessiblePages, locationResponse])

  useEffect(() => {
    if (channelList.length === 1 && customerList.length === 2) {
      const customerListForWholesale = customerList.filter((item, index) => index !== 0);

      setCustomer(customerListForWholesale[0]?.CustomerId)
    }
    else if (channelList.length && customerList.length)
      setCustomer(customerList[0]?.CustomerId)
  }, [customerList, channelList])


  useEffect(() => {
    if (customer === 'all') {
      setStoreIdOptions([All_LOCATION, ...storeObjects.filter(x =>
        (x.channel.toLowerCase() === SUPPLYCHAIN ? channelList.includes(x.channel.toLowerCase()) : true))
      ]);
    } else {
      setStoreIdOptions([All_LOCATION, ...storeObjects.filter(x => x.channel.toLowerCase() === customer.toLowerCase() || x.customerType.includes(customer))]);
    }
    setDepotIdOptions([All_LOCATION, ...depotObjects]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, storeObjects, customerList])

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  const handleChangeDepot = (event) => {
    const error1 = {};
    if (event.currentTarget.value === "") {
      error1.depotIdText = "Please select valid Depot Id";
      setDepoError(error1);
    }
    else {
      setDepoError(null);
    }
  };
  const handleChangeStore = (event) => {
    const error2 = {};
    if (event.currentTarget.value === "") {
      error2.storeIdText = "Please select valid Store Id";
      setStoreError(error2);
    }
    else {
      setStoreError(null)
    }
  };
  const handleCustomerChange = (event) => {

    setCustomer(event.target.value)
    setStoreId(["All"])
    setDepotId(["All"])

  };

  const errorMessage = React.useMemo(() => {

    if (errors === "disableFuture") {
      return "Order date cannot be more than today's date"
    }
    if (errors === "shouldDisableDate") {
      return "You can select maximum 21 days before the today's date"
    }
    if (errors === 'invalidDate') {
      return "Please enter date in correct format"
    }
  }, [errors]);

  /*  Validations   */
  const validate = () => {
    const errors = {};

    if (!depotId) {
      errors.depotIdText = "Please select valid Depot Id";
    }

    if (!storeId) {
      errors.storeIdText = "Please select valid Store Id";
    }

    if (orderDate && !dayjs(orderDate).isValid()) {
      errors.orderDateText = "Please enter date in correct format ";
    }

    if (dayjs().diff(orderDate, 'day') > 20) {
      errors.orderDateText = "You can select maximum 21 days before the today's date";
    }

    if (dayjs(orderDate).isAfter(dayjs())) {
      errors.orderDateText = "Order date cannot be more than today's date";
    }

    setErrors(errors);

    return !Object.keys(errors).length;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setShowFileDownloadPopup(true);
    if (validate()) {
      const encryptedEmailId = await encryptString(loginResponse?.email);

      const request = {
        apiKey: SOMS_API_KEY,
        params: {
          customerId: customer.toLowerCase(),
          depotId: depotIdInputValue === 'All' ? depotIdOptions.filter(x => typeof x.locationId === 'number').map(x => x.locationId) : [depotId],
          storeId: storeIdInputValue === 'All' ? storeIdOptions.filter(x => typeof x.locationId === 'number').map(x => x.locationId) : [storeId],
          orderedDate: orderDate?.format('YYYY-MM-DDTHH:mm:ss') || null,
          reportType: EMERGENCYORDER_DOWNLOAD_REPORT_TYPE,
          category: type,
          userId: encryptedEmailId,
        },

      }
      generateDownloadReport(request).then(response => {
        const { fileName } = response;

        const request = {
          apikey: SOMS_API_KEY,
          params: {
            fileName: fileName,
            reportType: EMERGENCYORDER_DOWNLOAD_REPORT_TYPE
          }
        }

        postFileAccess(request).then(response => {
          const url = response.fileURL
          const fileDownloadTag = document.createElement('a')
          fileDownloadTag.href = url
          fileDownloadTag.click();
          setShowDownloadUrl(true)
          setDownloadUrl(response.fileURL);
          setDownloadFileTime(response.validUpto);
          setShowFileDownloadPopup(false);
          dispatch(
            showNotificationDialogEmergencyOrder(
              "Download Successful",
              EMERGENCY_ORDER_DOWNLOAD_SUCCESS,
              'Done'
            )
          );
        }).catch(err => {
          const { errTitle, errContent } = showErrorMessageByCode(err)

          dispatch(
            showNotificationDialogEmergencyOrder(errTitle, errContent, 'Done')
          );

          setShowFileDownloadPopup(false);
          return false;
        })
      }).catch(err => {
        const { errTitle, errContent } = showErrorMessageByCode(err)

        dispatch(
          showNotificationDialogEmergencyOrder(errTitle, errContent, 'Done')
        );

        setShowFileDownloadPopup(false);
        return false;
      })
    } else {
      dispatch(
        showNotificationDialog("Download Failed", CORRECT_VALUE_SELECTION_EMERGENCYORDER, 'Done')
      );

      setShowFileDownloadPopup(false);
      return false;
    }
  };

  const disablePastDate = (date) => {
    const day = dayjs().subtract(21, "day");
    return !dayjs(day).isBefore(date);
  };

  return (
    <>
      {showFileDownloadPopup ? (
        <Dialog open={showFileDownloadPopup} maxWidth="sm" fullWidth={true}>
          <DialogTitle>File Downloading</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography sx={{ mt: 1 }} variant="subtitle2">
              To ensure the successful download, please avoid clicking the back
              button, leaving the page, or refreshing it during the download
              process
            </Typography>
          </DialogContent>
        </Dialog>
      ) : (
        <div></div>
      )}
      <div className="mainPageStyling">
        <Typography component="h1" variant="h5">
          Download Emergency Orders Lifecycle Report
        </Typography>
        <div className="labelControl">
          <Box
            sx={{
              my: 2,
              mb: 35,
            }}
          >
            <Grid component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <Grid container spacing={2} sx={{ "& > *": { flex: 1 } }}>
                <Grid item xs={6} md={3}>
                  <LabelWithControl label="Customer" labelId="customer" required={true}>
                    <FormControl fullWidth size="small">
                      {!customer && (
                        <InputLabel
                          id="customerLabel"
                          sx={{
                            "&.Mui-focused": { display: "none" },
                            "&.Mui-error": { color: "initial" },
                          }}
                          style={{ fontSize: "12px", top: "-4px" }}
                        >
                          Customer
                        </InputLabel>
                      )}
                      <Select
                        labelId="customerLabel"
                        id="customer"
                        className="dropDownValue"
                        value={customer}
                        onChange={handleCustomerChange}
                        size="small"

                        disabled={(channelList.length === 1)}
                      >
                        {customerList.map((x) => (
                          <MenuItem value={x.CustomerId}>{x.CustomerName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </LabelWithControl>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LabelWithControl label="Depot ID" labelId="depotId" required={true}>
                    <AutoComplete
                      id="depotId"
                      placeholderText="Depot ID"
                      onInputChange={(event, newInputValue) => {
                        setDepotIdInputValue(newInputValue);
                      }}
                      inputValue={depotIdInputValue}
                      onChange={(event, newValue) => {
                        setDepotId(newValue?.locationId);
                        handleChangeDepot(event)
                      }}
                      options={depotIdOptions}
                      value={depotId}
                      size="small"
                      error={!depotId ? errors?.depotIdText || depoError?.depotIdText : ""}
                      required={true}
                    />
                  </LabelWithControl>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LabelWithControl label="Store ID" labelId="storeId" required={true}>
                    <AutoComplete
                      id="storeId"
                      placeholderText="Store ID"
                      onInputChange={(event, newInputValue) => {
                        setStoreIdInputValue(newInputValue);
                      }}
                      inputValue={storeIdInputValue}
                      onChange={(event, newValue) => {
                        setStoreId(newValue?.locationId);
                        handleChangeStore(event)
                      }}
                      options={storeIdOptions}
                      value={storeId}
                      size="small"
                      error={!storeId ? errors?.storeIdText || storeError?.storeIdText : ""}
                      required={true}
                    />
                  </LabelWithControl>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LabelWithControl label="Order Date" required={true}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      size="small"
                      value={orderDate}
                      onChange={(x) => setOrderDate(x)}
                      defaultValue={dayjs(new Date())}
                      shouldDisableDate={disablePastDate}
                      disableFuture={true}
                      onError={(newError) => setErrors(newError)}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "Order Date ",
                          helperText: errors?.orderDateText || "" || errorMessage,
                          inputProps: { 'data-testid': 'order-date-input' },
                        },
                      }}
                    />
                  </LabelWithControl>
                </Grid>

              </Grid>

              <Grid container spacing={2} sx={{ "& > *": { flex: 1 } }}>

                <Grid item xs={6} md={3}>
                  <LabelWithControl label="Type" required={true}>
                    <FormControl fullWidth size="small">
                      <Select
                        labelId="type"
                        id="type"
                        value={type}
                        onChange={handleTypeChange}
                        className="dropDownValue"
                      >
                        {downloadType.map((x) => (
                          <MenuItem value={x.DownloadTypeId}>
                            {x.DownloadTypeName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </LabelWithControl>
                </Grid>

                <Grid item xs={4} md={2}>
                  <LabelWithControl labelVisible="hidden" label="Order ID" labelId="orderId">
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ width: "-webkit-fill-available", height: "25px", fontSize:"12px" }}
                      type="submit"
                      fullWidth
                    >
                      Download Report
                    </Button>
                  </LabelWithControl>
                </Grid>
                <Grid item>
                </Grid>
              </Grid>
              <Grid item>
                {showDownloadUrl ? <Typography style={{fontSize: '12px'}}><Link color="primary" underline="none" href={downloadUrl}>Click here</Link> to download the file. Valid till {downloadFileTime}.</Typography> : <div></div>}
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </>
  );
};
